// extracted by mini-css-extract-plugin
module.exports = {"slidefooter":"slidefooter--F-1tX","reset":"reset--2tJ9_","confirm":"confirm--1mrDm"};